import React from 'react'
import { PaymentTypeItem } from '../PaymentTypeItem'

export function ListPaymentTypes({ payments }) {
  return (
    <div data-testid="container-payment-types-list">
      {payments?.map((payment, index) => (
        <PaymentTypeItem
          key={`payment_type_${payment?.PaymentName?.toLowerCase()}_${index}`}
          payment={payment}
        />
      ))}
    </div>
  )
}
